/* AKKURANDO 17.10.2026: Sofortvorschläge im Suchfeld der Startseite (Präfix akh-sug).
   Nutzt dieselbe Serverantwort wie die Suche in der Kopfzeile (Abschnitt „search-drawer“: Produkte + Suchhilfe für
   Vergleichsnummern und Geräte, snippets/akk-search-hint.liquid), zeigt aber nur Produkte. Ohne Skript bleibt das Feld ein normales Suchformular. */
(function () {
  var form = document.querySelector('[data-akh-search]');
  if (!form || form.dataset.sugReady || !window.fetch || !window.DOMParser) return;
  form.dataset.sugReady = '1';
  var input = form.querySelector('input[type=search]');
  var base = (window.theme && theme.routes && theme.routes.predictive_search_url) || '/search/suggest';
  var SECTION = 'search-drawer';
  var panel = document.createElement('div');
  panel.className = 'akh-sug';
  panel.id = 'akh-sug';
  panel.hidden = true;
  var status = document.createElement('p');
  status.className = 'akh-sr';
  status.setAttribute('role', 'status');
  form.appendChild(status);
  form.appendChild(panel);
  input.setAttribute('aria-controls', 'akh-sug');
  input.setAttribute('aria-expanded', 'false');
  var timer, abort, cache = {};

  function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
  function show(nodes, n) {
    panel.replaceChildren.apply(panel, nodes);
    panel.hidden = !nodes.length;
    input.setAttribute('aria-expanded', String(!panel.hidden));
    status.textContent = n ? (n === 1 ? '1 Produkt' : n + ' Produkte') + ' unter dem Suchfeld vorgeschlagen.' : '';
  }
  function render(text, q) {
    var box = new DOMParser().parseFromString(text, 'text/html').querySelector('[id^="PredictiveSearchResults-"]');
    var nodes = [], prods = box ? box.querySelectorAll('.horizontal-product') : [], hint = box && box.querySelector('.aksh');
    if (hint) nodes.push(document.importNode(hint, true));
    if (prods.length) {
      var list = document.createElement('div');
      list.className = 'akh-sug__list';
      [].forEach.call(prods, function (p) { list.appendChild(document.importNode(p, true)); });
      nodes.push(list);
      var all = document.createElement('a');
      all.className = 'akh-sug__all';
      all.href = (form.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
      all.textContent = 'Alle Treffer für „' + q + '“ anzeigen';
      nodes.push(all);
    }
    show(nodes, prods.length);
  }
  function load(q) {
    if (cache[q]) return render(cache[q], q);
    if (abort) abort.abort();
    abort = window.AbortController ? new AbortController() : null;
    var url = base + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[limit_scope]=each&section_id=' + SECTION;
    fetch(url, abort ? { signal: abort.signal } : {}).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { cache[q] = t; if (input.value.trim() === q) render(t, q); })
      .catch(function () { /* still: Feld bleibt ein normales Suchformular */ });
  }
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { close(); return; }
    timer = setTimeout(function () { load(q); }, 250);
  });
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { close(); input.focus(); }
  });
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 0); });
  form.addEventListener('submit', close);
})();
